
import {Button as ChakraButton, IconButton as ChakraIconButton} from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Button = styled(ChakraButton)`
`

export const IconButton = styled(ChakraIconButton)`
  border-radius: 1px;
`